import { getSingleInstanceByName, initialiseComponents } from "../../core";
import {createElementFromHTML} from "@utils/html/html.utils";

export default class GridContents {
  private grid: HTMLElement;
  private elements: Element[];
  private nextSibling: Element;

  constructor(grid: HTMLElement) {
    this.grid = grid;
    if (window.innerWidth > 767) {
      this.init();
    }
  }

  init(): void {
    // switch content parts in order to give a beautiful grid, a group of linked content is made a .cut fellows
    let current = [];
    const contents = this.grid.children;
    for (let i = 0; i < contents.length; i++) {
      if (!contents[i].classList.contains("side")) {
        if (
          contents[i].classList.contains("cut") ||
          contents[i].classList.contains("xlcut") ||
          contents[i].classList.contains("mdcut") ||
          contents[i].classList.contains("lgcut")
        ) {
          current.push(contents[i]);
        } else {
          if (current.length) {
            // create a copy
            const arr = [];
            for (let k = 0; k < current.length; k++) {
              arr.push(current[k]);
            }
            this.elements = arr;
            this.nextSibling =
              this.elements[this.elements.length - 1].nextElementSibling;
            this.initElements();
            current = [];
          }
        }
      }
    }

    if (current.length) {
      // no copy needed we will work with this array
      this.elements = current;
      this.nextSibling =
        this.elements[this.elements.length - 1].nextElementSibling;
      this.initElements();
    }
  }

  initElements(): void {
    // sort the elements to reorder them
    // the rules are
    // if there is an important element (data-grid-high), starts with it
    // if an important element starts a row, the next one can't start the a row but can finish it
    // two importants elements can't follow themselves
    // if there is no element, put something from the gallery
    // take the thing quite fluently
    // but the first empty room is fullfilled by a placeholder if there isn't enough low element
    // those rules are made from a "vue d'esprit" :crazy:

    // this boolean tell that the next important element must start its row
    let startIm = true;
    // count
    let nbimportant = 0;
    for (let i = 0; i < this.elements.length; i++) {
      if (this.elements[i].hasAttribute("data-grid-high")) {
        nbimportant++;
      }
    }
    // tell if there is the need of a placeholder next to the first important element
    let needStart = (this.elements.length - nbimportant * 2) % 2 == 1;
    // we work with only one array and as we are moving some elements inside it, take care that an element can be worked two times but that's the deal
    for (let i = 0; i < this.elements.length; i++) {
      // check the column we are on
      const start = i % 2 == 0;
      if (this.elements[i].hasAttribute("data-grid-high")) {
        if (start) {
          // we are on the first column and the next important must be on the first row, perfect, we just have to ensure that the next one is not important
          if (startIm) {
            startIm = false;
            // first empty place needs a placeholder for the gallery if needStart is setted to true
            const noim = this.findNoImportant(i + 1, needStart);
            if (noim) {
              // jump to the next array beacause there is nothing more to do here and we have a rule to check
              i++;
              this.elements.splice(i, 0, noim);
            }
            needStart = false;
          } else {
            startIm = true;
            // not perfect, we have to push something before and break the loop
            // here, we don't have to check the needStart value because it happens when startIm is setted to true
            // find if there is something we can take from the last elements
            // push the element at the current index, so the actual one will be pushed to the index after
            const noim = this.findNoImportant(i + 1);
            if (noim) {
              this.elements.splice(i, 0, noim);
              //back to the future to the actual element
              i++;
            }
          }
        } else {
          if (startIm) {
            // if we have to start the room with an important thing, we are sure that we can put this one there,
            // because of the jumps from the first part of the alg, we can switch with the last one (which is not important)
            //(we are on the end row, so, the start row has been aleady done, we dont have to create a placeholder)
            const noim = this.findNoImportant(i - 1);
            if (noim) {
              this.elements.splice(i, 0, noim);
            }
            startIm = false;
          } else {
            // we are on the second column and the important element must be setted there, so there is nothing to do, only to tell it
            startIm = true;
          }
        }
      } // in other cases, let the beat goes on but when there is no important thing
      else {
        if (nbimportant == 0 && start && needStart) {
          const noim = this.findNoImportant(i + 1, needStart);
          if (noim) {
            // first empty place needs a placeholder for the gallery if needStart is setted to true
            i++;
            this.elements.splice(i, 0, noim);
          }

          needStart = false;
        }
      }
    }
    // now, play with the dom!!!
    if (this.elements.length % 2 == 1) {
      const ph = this.createPlaceholder();
      if (ph) {
        this.elements.push(ph);
      }
    }
    for (let i = 0; i < this.elements.length; i++) {
      this.grid.insertBefore(this.elements[i], this.nextSibling);
    }

    initialiseComponents();
  }

  findNoImportant(startIndex: number, forcePlaceholder?: boolean): Element {
    if (forcePlaceholder) {
      return this.createPlaceholder();
    }
    let result: Element;
    for (let j = startIndex; j < this.elements.length && !result; j++) {
      if (
        !this.elements[j].hasAttribute("data-grid-high") &&
        !this.elements[j].hasAttribute("data-grid-cuttable")
      ) {
        result = this.elements.splice(j, 1)[0];
      }
    }
    return result || this.createPlaceholder();
  }

  createPlaceholder(): Element {
     if (
       getSingleInstanceByName("Gallery") &&
       getSingleInstanceByName("GalleryPlaceholder")
     ) {
            return createElementFromHTML(
              '<div data-component data-bt data-gallery-placeholder class="content cut fill ratioactive minratio"></div>'
            ) as Element;
     }
   
}
}
